export default {
  titulo: "Services",
  nuevo: "New service",
  busqueda: "Search by order number, equipment, customer name or issue",
  hayPlural: "There are",
  haySingular: "There is",
  textAgendadosPlural: "Scheduled services for",
  textAgendadosSingular: "Scheduled service for",
  errorApertura: "You must initiate the service",
  tipo: "Service type",
  pregEliminar: "Are you sure you want to delete the service order?",
  eliminarPrev: "Delete preventive service",
  pregEliminarPrev: "Are you sure you want to delete the preventive service?",
  estaPrev: "Delete only this order",
  todasPrev: "This order and all related ones",
  futurasPrev: "This order and future related ones",
  msgErrorPlan: "Your SatWeb plan does not include the Services module. To use it, you must subscribe to another plan",
  grados: {
    Normal: "Normal",
    Urgente: "Urgent",
    Emergencia: "Emergency"
  },
  tipos: {
    Correctivo: "Corrective",
    Preventivo: "Preventive",
    Predictivo: "Predictive",
    Mejorativo: "Improvement",
    Instalacion: "Installation"
  },
  tituloVerOrden: "Service Order ",
  informeMantencion: "Maintenance report",
  gestion: "Management indicators",
  finalizar: "Finish",
  iniciar: "Start",
  detener: "Pause order",
  reanudar: "Resume order",
  pregDetener: "Are you sure you want to pause the order?",
  motivo: "Please indicate the reason",
  pregReanudar: "Are you sure you want to resume the order?",
  pregIniciar: "Are you sure you want to start the order?",
  pregFinalizar: "Are you sure you want to finalize the service order?",
  hora: "Time",
  imprimirFinalizada: "Print completed order report",
  solicitud: "Request",
  inicio: "Route start",
  apertura: "Opening",
  detectada: "Issue detected",
  reparada: "Issue resolved",
  finalizacion: "Completion",
  detenido: "Paused",
  total: "Total attention",
  msgPin: "Client PIN is required to initiate the service opening",
  textSeleccionarCliente: "Select an option to enter customer data.",
  registrarCliente: "Register a new customer",
  buscarCliente: "Search a registered customer",
  detallesCliente: "Customer details",
  noDataCliente: "No customer has been selected",
  textOrdenSinEquipo: "Enable this option if the order has no associated equipment",
  registrarEquipo: "Register new equipment",
  buscarEquipo: "Search registered equipment",
  detallesEquipo: "Equipment details",
  noDataEquipo: "No equipment has been selected",
  siniestro: "Order with insurance claim",
  planMantenimiento: "Maintenance plan",
  repetir: "Repeat",
  noRepetir: "Do not repeat",
  categoria: "Category",
  nroManual: "Manual order number",
  asignacion: "Technician assignment",
  msgAsignacion: "If you assign the service order to someone else, you will be notified so you’re aware of the new task",
  usuario: "User",
  grupo: "Group",
  frecuencia: "Frequency",
  repetirCada: "Repeat every",
  msgFechaInvalida: "Must be equal to or greater than the start date",
  dia: "Day",
  dias: "Days",
  mes: "Month",
  meses: "Months",
  msgStep1: "To proceed with the service, you must select a Customer",
  msgStep2: "To proceed with the service, you must select Equipment",
  msgStep3: "To proceed with the service, you must describe the issue",
  msgStep4: "To proceed, you must select a technician",
  cada: "Every",
  desde: "from",
  hasta: "to",
  ingreso: "Entry",
  verRegistros: "View order logs",
  tituloRegistros: "Service order logs",
  estados: {
    "Sin Realizar": "Not Started",
    "En Proceso": "In Progress",
    "Realizado": "Completed"
  },
  personaContacto: "Contact person",
  asociarEquipo: "Associate equipment to order",
  msgNoHayPermiso: "You do not have permission to modify this order",
  problema: "Reported issue",
  editarProblema: "Edit reported issue",
  reagendar: "Reschedule",
  fechaReclamo: "Request date",
  sucursalReclamo: "Request branch",
  deptoReclamo: "Request department",
  gradoReclamo: "Request severity",
  estadosReclamo: "Request status",
  textInforme: "Enter the service report",
  nuevaNota: "New note",
  eliminarNota: "Delete note",
  pregEliminarNota: "Are you sure you want to delete this note?",
  presupuesto: {
    manoObra: "Labor",
    repuestos: "Parts",
    entrega: "Down payment",
    impuestos: "Taxes",
    total: "Total estimate",
    email: "Send by Email",
    wpp: "Send by WhatsApp"
  },
  convertirReclamo: "Generating corrective service order from request #",
  equipoIngresado: "Equipment entered by customer",
  usarEquipo: "Use this equipment",
  eliminarReclamo: "Are you sure you want to delete the request?"

}
